const BOOKING_OPTIONS = Object.freeze([
    {
        sugarAPIName: 'Private Cremation & Return of Ashes',
        vetRelationshipType: 'vet_direct',
        label: 'Private Cremation & Return of Ashes',
        feedback: 'Book a private cremation on behalf of the pet owner',
        path: '/new-booking/private'
    },
    {
        sugarAPIName: 'Private Cremation & Return of Ashes',
        vetRelationshipType: 'vet_direct',
        label: 'Private Cremation & Return of Ashes: Cremation Package',
        feedback: 'Book a private cremation (on behalf of the pet owner) as part of a cremation package',
        path: '/new-booking/package'
    },
    {
        sugarAPIName: 'Private Cremation & Return of Ashes',
        vetRelationshipType: 'referral',
        label: 'Private Cremation & Return of Ashes: Referral',
        feedback: 'Refer a private cremation to {brand} for completion. Ashes will be returned to the client.',
        path: '/new-booking/referral'
    },
    {
        sugarAPIName: 'Private Cremation & Return of Ashes',
        vetRelationshipType: 'vet_unity',
        label: 'Private Cremation & Return of Ashes',
        feedback: 'Book a private cremation on behalf of the pet owner.',
        path: '/new-booking/vetunity-private'
    },
    {
        sugarAPIName: 'Private Cremation & Dispersal of Ashes',
        vetRelationshipType: 'vet_direct',
        label: '[No Ashes Return] Private Cremation & Dispersal of Ashes',
        feedback: 'Pet will be privately cremated with ashes dispersed on a private property. <b> Custom product selection is available </b>',
        path: '/new-booking/private'
    },
    {
        sugarAPIName: 'Private Cremation & Dispersal of Ashes',
        vetRelationshipType: 'vet_direct',
        label: '[No Ashes Return] Private Cremation & Dispersal of Ashes: Cremation Package',
        feedback: 'Pet will be privately cremated with ashes dispersed on a private property. <b> Not available with any other products. </b>',
        path: '/new-booking/package'
    },
    {
        sugarAPIName: 'Private Cremation & Dispersal of Ashes',
        vetRelationshipType: 'referral',
        label: '[No Ashes Return] Private Cremation & Dispersal of Ashes: Referral',
        feedback: 'Refer a private cremation to {brand} for completion. Ashes will be dispersed on a private property.',
        path: '/new-booking/referral'
    },
    {
        sugarAPIName: 'Private Cremation & Dispersal of Ashes',
        vetRelationshipType: 'vet_unity',
        label: '[No Ashes Return] Private Cremation & Dispersal of Ashes',
        feedback: 'Pet will be privately cremated with ashes dispersed on a private property.',
        path: '/new-booking/vetunity-private'
    },
    {
        sugarAPIName: 'Communal Cremation - Vet',
        vetRelationshipType: 'vet_unity',
        label: 'Communal Cremation - Pet',
        feedback: 'Book a communal cremation on behalf of the pet owner.',
        path: '/new-booking/vetunity-communal'
    },
    {
        sugarAPIName: 'Communal Cremation - Stray / Wildlife - Vet',
        vetRelationshipType: 'vet_unity',
        label: 'Communal Cremation - Stray/Wildlife',
        feedback: 'Book a communal cremation for a stray/wildlife.',
        path: '/new-booking/vetunity-communal'
    },
    {
        sugarAPIName: 'Communal Cremation - Vet',
        vetRelationshipType: null,
        label: 'Communal Cremation - Vet: Keepsakes',
        feedback: 'Book a communal cremation (on behalf of the pet owner) with paw print or fur keepsakes',
        path: '/new-booking/communal'
    },
    {
        sugarAPIName: 'Products Only',
        vetRelationshipType: null,
        label: 'Products Only Order',
        feedback: 'Order urns and memorabilia (on behalf of the pet owner) without booking a cremation.',
        path: '/new-booking/urns-and-memorabilia'
    },

    {
        sugarAPIName: 'Vet Supply Order',
        vetRelationshipType: null,
        label: 'Vet Supply Order',
        feedback: 'Order supplies and consumables for your practice',
        path: '/new-booking/vet-supply-order'
    }
]);

export default BOOKING_OPTIONS;